import { z } from 'zod';

export const CreateDataSetPostProcessingScriptSchema = z.object({
  scriptUserUploadId: z.string(),
});

export type CreateDataSetPostProcessingScriptBodyType = z.infer<
  typeof CreateDataSetPostProcessingScriptSchema
>;
